module.exports = __webpack_public_path__ + "static/media/close-btn.65aa9545.svg";